import React, { useState, useCallback, useRef, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import AgeGate from './components/AgeGate';
import DildoViewer from './components/DildoViewer';
import ControlPanel from './components/ControlPanel';
import TopBar from './components/TopBar';
import About from './pages/About';
import { DEFAULT_PARAMS, PRESETS, randomPreset, sanitizeParams } from './utils/presets';
import { getShareFromUrl, decodeShare } from './utils/shareUtils';
import './App.css';

function MainApp() {
  const navigate = useNavigate();

  const [ageConfirmed, setAgeConfirmed] = useState(() => {
    const shareData = getShareFromUrl();
    return shareData ? true : localStorage.getItem('ageConfirmed') === 'true';
  });

  const [params, setParams] = useState(() => {
    const shareData = getShareFromUrl();
    return shareData ? sanitizeParams(shareData.params) : { ...DEFAULT_PARAMS };
  });

  const [caption, setCaption] = useState(() => {
    const shareData = getShareFromUrl();
    return shareData ? shareData.caption : '';
  });

  const [isSharedView] = useState(() => !!getShareFromUrl());
  const [isRotating, setIsRotating] = useState(true);
  const [isPanelOpen, setIsPanelOpen] = useState(() => !getShareFromUrl());
  const [menuOpen, setMenuOpen] = useState(false);
  const [preview, setPreview] = useState(null);
  const exportRef = useRef(null);

  const handlePreview = (url) => {
    try {
      const encoded = new URL(url).searchParams.get('share');
      const data = encoded ? decodeShare(encoded) : null;
      if (data) setPreview({ params: sanitizeParams(data.params), caption: data.caption });
    } catch (_) {}
  };

  const handleAgeConfirm = () => {
    setAgeConfirmed(true);
    localStorage.setItem('ageConfirmed', 'true');
  };

  const handleDesignYours = () => {
    setIsPanelOpen(true);
    setMenuOpen(false);
  };

  const updateParam = useCallback((key, value) => {
    setParams(prev => ({ ...prev, [key]: value }));
  }, []);

  const handleRandom = useCallback(() => {
    setParams(randomPreset());
  }, []);

  const handleReset = useCallback(() => {
    setParams({ ...DEFAULT_PARAMS });
  }, []);

  const handlePreset = useCallback((key) => {
    if (PRESETS[key]) setParams({ ...PRESETS[key] });
  }, []);

  const handleToggleRotate = useCallback(() => {
    const next = !isRotating;
    setIsRotating(next);
    if (exportRef.current?.setAutoRotate) exportRef.current.setAutoRotate(next);
  }, [isRotating]);

  const handleViewerReady = useCallback((api) => {
    exportRef.current = api;
  }, []);

  if (!ageConfirmed) {
    return <AgeGate onConfirm={handleAgeConfirm} />;
  }

  if (preview) {
    return (
      <div className="relative w-screen h-screen overflow-hidden bg-[#030405]">
        <DildoViewer params={preview.params} isPanelOpen={false} onReady={() => {}} onAutoRotateOff={() => {}} />

        {preview.caption && (
          <div className="absolute top-20 left-0 right-0 z-50 flex justify-center pointer-events-none">
            <div className="px-8 py-4 bg-[#06090e]/50 border border-[#00F0FF]/40 backdrop-blur-lg rounded max-w-3xl shadow-lg"
              style={{ boxShadow: '0 0 20px rgba(0,240,255,0.2)' }}>
              <p className="text-center text-[#00F0FF] font-light italic whitespace-normal break-words"
                style={{ fontSize: 'clamp(20px, 6vw, 48px)', lineHeight: '1.4' }}>"{preview.caption}"</p>
            </div>
          </div>
        )}

        <button
          onClick={() => setPreview(null)}
          className="absolute top-4 right-4 z-50 px-3 py-1.5 text-[9px] uppercase tracking-[0.18em] border border-[#00F0FF]/30 text-[#00F0FF]/60 hover:text-[#00F0FF] hover:border-[#00F0FF]/60 transition-colors bg-[#06090e]/80"
        >
          ✕ Close preview
        </button>

        <div className="absolute bottom-16 left-1/2 transform -translate-x-1/2 z-50">
          <span className="text-[11px] font-mono uppercase tracking-[0.2em] text-[#00F0FF]/50">
            ✓ Link copied
          </span>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="main-app" className="relative w-screen h-screen overflow-hidden bg-[#030405]">
      {/* Shared view caption */}
      {isSharedView && caption && !isPanelOpen && (
        <>
          <div className="absolute top-20 left-0 right-0 z-[35] flex justify-center pointer-events-none">
            <div className="px-8 py-4 bg-[#06090e]/50 border border-[#00F0FF]/40 backdrop-blur-lg rounded max-w-3xl shadow-lg"
              style={{ boxShadow: '0 0 20px rgba(0,240,255,0.2)' }}>
              <p className="text-center text-[#00F0FF] font-light italic whitespace-normal break-words"
                style={{ fontSize: 'clamp(20px, 6vw, 48px)', lineHeight: '1.4' }}>{caption}</p>
            </div>
          </div>
          <button
            onClick={handleDesignYours}
            className="absolute bottom-16 left-1/2 transform -translate-x-1/2 z-[35] px-8 py-3 bg-[#00F0FF]/20 hover:bg-[#00F0FF]/30 border border-[#00F0FF]/50 hover:border-[#00F0FF]/80 text-[#00F0FF] text-[13px] uppercase tracking-[0.15em] font-medium transition-all duration-150 rounded pointer-events-auto"
          >
            Design yours
          </button>
        </>
      )}

      <DildoViewer
        params={params}
        isPanelOpen={isPanelOpen}
        onReady={handleViewerReady}
        onAutoRotateOff={() => setIsRotating(false)}
      />
      <TopBar
        params={params}
        onRandom={handleRandom}
        onReset={handleReset}
        onExportSTL={() => exportRef.current?.exportSTL()}
        onExportOBJ={() => exportRef.current?.exportOBJ()}
        onToggleRotate={handleToggleRotate}
        isRotating={isRotating}
        onPreview={handlePreview}
        menuOpen={menuOpen}
        onMenuOpenChange={setMenuOpen}
      />
      <ControlPanel
        params={params}
        isPanelOpen={isPanelOpen}
        onTogglePanel={() => setIsPanelOpen(!isPanelOpen)}
        onUpdate={updateParam}
        onPreset={handlePreset}
      />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainApp />} />
        <Route path="/about" element={<About />} />
        <Route path="/about/:lang" element={<About />} />
      </Routes>
    </BrowserRouter>
  );
}
